// Modules
import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { RootState } from '../types/store';

// Project
import AppActions from '../actions/app-actions';

export default function Speaker() {
    const speaker = useSelector((state:RootState) => state.page.speaker);
    const translate = useSelector((state:RootState) => state.ui.language.speaker);
    const dispatch = useDispatch();
    const [current, setCurrent] = useState(0);
    const [showAnswer, setShowAnswer] = useState(false);

    function onShowAnswer() {
        setShowAnswer(true);
    }
    
    function onNext() {
        if(speaker.questions && speaker.questions.length > current) {
            dispatch(AppActions.SpeakerNext({ lobby: speaker.code, question: (current+1)}));
            setCurrent(current+1);
            setShowAnswer(false);
        }
    }

    if(speaker.questions.length === 0) {
        return(<div className="container-fluid justify-content-center h-index">
            <div className="row h-100">
                <div className="col-xl-4 col-lg-5 col-md-7 col-sm-9 col-11 box box-shadow box-padding text-center my-auto mx-auto">
                    <h2 className="lh-11 mt-4 mb-4">{translate.noQuestionsFound}</h2>

                    <div className="row">&nbsp;</div>
                    <div className="row justify-content-sm-center">
                        <div className="col-lg-8 col-sm-8">
                            <Link to="/create" className="btn btn-custom btn-xl">{translate.create}</Link>
                        </div>
                    </div>
                    <div className="row">&nbsp;</div>
                    <div className="row justify-content-sm-center">
                        <div className="col-lg-8 col-sm-8">
                            <Link to="/" className="btn btn-custom btn-xl">{translate.back}</Link>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>);
    }

    // Last question has been answered. We be done now!
    if(current === speaker.questions.length) {
        return(<div className="container-fluid justify-content-center h-index">
            <div className="row h-100">
                <div className="col-xl-4 col-lg-5 col-md-7 col-sm-9 col-11 box box-shadow box-padding text-center my-auto mx-auto">
                    <h2 className="lh-11 m-4">{translate.roundFinished}</h2>
            
                    <div className="row">&nbsp;</div>
                    <div className="row justify-content-sm-center">
                        <div className="col-lg-8 col-sm-8">
                            <Link to="/create" className="btn btn-custom btn-xl">{translate.create}</Link>
                        </div>
                    </div>
                    <div className="row">&nbsp;</div>
                    <div className="row justify-content-sm-center">
                        <div className="col-lg-8 col-sm-8">
                            <Link to="/play" className="btn btn-custom btn-xl">{translate.back}</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>);
    }

    let q = speaker.questions[current];
    let options:any[] = [];
    let hasAnswer = undefined;
    let extra:React.JSX.Element = <></>;

    if(current < speaker.questions.length && speaker.questions[current].correct >= 0) {
        let c = speaker.questions[current].correct
        hasAnswer = (<div className="col-lg-12 col-sm-10 mb-2">
            <button className="btn btn-custom btn-xl btn-moes-shadow">{speaker.questions[current].options[c].option}</button>
        </div>);
        let e = speaker.questions[current].extra;
        if(e && e.length > 0) extra = (<div className="col-sm-12 text-center">{speaker.questions[(current-1)].extra}</div>);
    }

    if(q.options.length > 0) {
        //options.push(<div className="row">&nbsp;</div>);
        q.options.forEach( (v:any, i:number) => {
            //if(i > 0) options += ", ";
            options.push(<div key={i} className="col-sm-12"><h3>{v.option.replace("%p", translate.personLeftOfYou)}</h3></div>);
            //options += (i+1)+") "+v.option+"";
        });
    }

    let tip:React.JSX.Element = <></>;
    let tips:any[] = [];
    if(current === 0) {
        // Show a tip on the first round

        translate.tips.forEach( (v:any, i:any) => {
            tips.push(<div className="col-sm-12" key={i}><b><i>{v}</i></b></div>);
        });
        tip = (<div className="row justify-content-center pt-4">{tips}</div>);
    }

    return(
        <div className="container-fluid h-index">
            <div className="row h-100">
                <div className="col-10 my-auto mx-auto text-center">
                    {tip}
                    <div className="row">&nbsp;</div>
        
                    <div className="row justify-content-center"><div className="col-lg-12 col-sm-12"><h2 className="lh-11 question-size mb-2">{q.question}</h2></div></div>
    
                    <div className="row justify-content-center">
                        {options}
                    </div>
                    <div className="row">&nbsp;</div>
    
                    <div className="row justify-content-center">
                        {hasAnswer && !showAnswer && <div className="col-sm-12 col-lg-6 col-md-12 mb-3">
                            <button className="btn btn-custom btn-xl" type="button" onClick={onShowAnswer}>{translate.showAnswer}</button>
                        </div>}
                        {(showAnswer || !hasAnswer) && <div className="col-sm-12 col-lg-6 col-md-12 mb-3">
                            {hasAnswer}<br />
                            {extra}<br />
                            <button className="btn btn-custom btn-xl" type="button" onClick={onNext}>{translate.next}</button>
                        </div>}
                    </div>
                </div>
            </div>
        </div>
    );
}
